export interface GradeConfigEntry {
	label: string;
	color: string;
	bg: string;
}

/**
 * Grade display config shared by the asset results grid (AssetsResults) and the
 * asset curve dialog (AssetCurveDialog). Keyed by the API grade value so both
 * views render identical labels and colours.
 */
export const GRADE_CONFIG: Record<string, GradeConfigEntry> = {
	extreme: { label: 'CRITICAL', color: '#8B5CF6', bg: '#f3ebff' },
	high: { label: 'CONCERNING', color: '#EC4899', bg: '#fce7f3' },
	medium: { label: 'MODERATE', color: '#F59E0B', bg: '#fef3c7' },
	low: { label: 'STABLE', color: '#14B8A6', bg: '#ccfbf1' },
	negligible: { label: 'OPTIMAL', color: '#3B82F6', bg: '#dbeafe' },
};
